// extracted by mini-css-extract-plugin
export default {"date-slider":"DateSlider_date-slider__fBSKo"};